<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/w5WLhg/tc-custom/9781645366225.jpg?1719602265474" alt="This image is the cover for the book Rich White Americans"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rich White Americans
      </h1>
      <p class="bookDescription body article font2">
        <p>Part thriller, part action adventure—this story is from the standpoint of a young woman who foils sexual assault. It’s 1963 and Inny spends a summer in her parents’ new home in swank Montecito while waiting to finish her senior year at UC Berkeley. She’s determined to graduate, but when a senator’s stepson stalks her back to Berkeley, neither her family nor her first real love can protect her from the heart of darkness.</p><p><br/></p><p>“Once I started reading this five-star novel, I couldn’t put it down. What a riveting adventure of a young woman experiencing the best and worst of partying with some of the richest men in Montecito while determined to get her college degree and earn her own living. Her infectious optimism and ability to enjoy life is an inspiration. It’s bigger than real life—full of lust, love, and compassion. I can’t wait for the film version, but, in the meantime, every college girl should read this book!” – Alexis Rafael, author of <em>Sex and the Cyborg Goddess.</em></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Virginia Dale
      </h2>
      
      <p class="authorDescription body article"><p class="Default" style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;color:black;text-align:justify;'><span style="font-size:15px;">Virginia Dale has had two other books published: <em>Never Marry in Morocco </em>(Fifthian Press, 1996) and <em>The Bushy Daughters Go to War and Find Rumi</em> (iUniverse, 2007). Both received good reviews in the <em>Santa Barbara Independent</em>, and she was scheduled for readings by them at the local book stores. There were several bookstores in 1996, and there is still an excellent independent one named Chaucer&rsquo;s.</span></p><p style='margin:0cm;margin-bottom:.0001pt;font-size:15px;font-family:"Times New Roman",serif;text-align:justify;'><br></p><p style='margin:0cm;margin-bottom:.0001pt;font-size:15px;font-family:"Times New Roman",serif;text-align:justify;'>She lived abroad for seven years in Madrid, Spain and Rabat, Morocco, where she became well acquainted with the Spanish, French, and Moroccan cultures. She currently resides in Santa Barbara, California.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dec8450c